module.exports = __webpack_public_path__ + "static/media/img-5e95d366-6bf1-11ee-817c-0a1ea4c5532f.8c891fcb.png";